import React, { Component} from 'react';
import { toast, Slide } from 'react-toastify';
//import Icon from "./icon";

const iconTypes = {
	'success': 'alert-success',
	'failure': 'alert-danger',
	'info': 'alert-info'
};

class Toaster extends Component {
    constructor(props) {
		super(props);
        this.state = {
            type : props.type,
		    message : props.message
        };
        this.renderToastBody = this.renderToastBody.bind(this);
        this.renderToastDescription = this.renderToastDescription.bind(this);
    }

    renderToastBody (){
		let { message } = this.state;
        if(message && typeof message === 'object') {
			return (
				<div>
					<div className="flex-1">
						<div className="Toastify__toaster-title">{message.header}</div>
					</div>
				</div>
			);
		}

		return <div className="flex-1"><div className="Toastify__toaster-title">{message}</div></div>
	};

	renderToastDescription (){
         let { message } = this.state;
        if(message && typeof message === 'object') {
			if(!message.description) return null;

			return (
				<div className="d-flex">
					<div style={{flex: "0 0 37px"}}></div>
					<div className="Toastify__toaster-description">{message.description}</div>
					<div className="ml-5"></div>
				</div>
			);
		}

		return null;
	};
	
    render() {
        return (
            <div>
                <div className="d-flex flex-wrap flex-col">
                    <div className="d-flex align-items-center">
                        {this.renderToastBody()}
                    </div>
                    {this.renderToastDescription()}
                </div>
            </div>
        );
    }
}


const showToaster = (type, message) => {
	const toastType = {
		success: toast.TYPE.SUCCESS,
		failure: toast.TYPE.ERROR
	};

	const toastClassName = {
		success: 'success-toast',
		failure: 'error-toast',
		info: 'info-toast'
	}

	const toastOptions = {
		position: toast.POSITION.TOP_CENTER,
		autoClose: 30000, //30000
		draggablePercent: 60,
		transition: Slide,
		type: type && toastType[type] ? toastType[type] : toast.TYPE.DEFAULT,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: false,
		closeButton: true,
		className: toastClassName[type]
	}

	toast(<Toaster type={type} message={message} />, toastOptions);
}

export default showToaster;


// WEBPACK FOOTER //
// ./public/react/components/toaster.js